<form class="form-inline">
  <!-- <div class="form-group"> -->
    <div class="dateicon input-group" id="dateRangePicker">
     
      <input class="form-control" id="dateRange" [placeholder]="placeholder" name="dp" [value]="formattedDateRange" ngbDatepicker
        #dp="ngbDatepicker" [displayMonths]="2" [dayTemplate]="t" [autoClose]="false" (dateSelect)="onDateSelection($event)" (click)="toggle()"
        readonly />
        <i><img src="assets/media/icons/png/calender.png" (click)="toggle()"></i>
    </div>
  <!-- </div> -->
</form>

<ng-template #t let-date="date" let-focused="focused">
  <span class="custom-day" [class.focused]="focused" [class.range]="isFrom(date) || isTo(date) || isInside(date) || isHovered(date)"
    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = toDate(date)" (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>